// extracted by mini-css-extract-plugin
export default {"wrapper":"coachMessagePage_wrapper__-B7ep","title":"coachMessagePage_title__7mqLH","mainContentWrapper":"coachMessagePage_mainContentWrapper__Uki0-"};